// extracted by mini-css-extract-plugin
export var form = "GiftCard-module--form--632a3";
export var header = "GiftCard-module--header--8e106";
export var priceContainer = "GiftCard-module--priceContainer--b5bdb";
export var sumContainer = "GiftCard-module--sumContainer--afdb0";
export var wrapper = "GiftCard-module--wrapper--afd6f";